// listing page bundle -> dist/js/pages/listing.min.js
//
// Plain-ES port of the v3 resources interactions (originally the React/DCLogic
// component people-equation/dc/resources.logic.js on feat/v3-design-pages),
// shared by all six listing pages. No framework: the cards, tabs and chips are
// server-rendered by the shared listing engine; this only shows/hides what is
// already in the DOM. Behaviours ported:
//   - the data-rv reveal (IntersectionObserver fade-in for the newsletter)
//   - the category tab switch + the format-filter chips (with per-tab chip
//     availability, exactly like the v3 kindList)
//   - "Load more" pagination (cardsPerPage), the "N of M" counter, the
//     empty-state, and the grid opacity swap on filter change
// The shared nav (scroll auto-hide, dropdown panels, mobile menu) and the
// newsletter submit live in chrome.js and load on every page.

(function () {
  "use strict";

  var root = document.querySelector(".pe-listing");
  if (!root) return;

  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // --- data-rv reveal (newsletter blocks) ---------------------------------
  var revealables = $$("[data-rv]", root);
  if (revealables.length) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.opacity = "1";
            e.target.style.transform = "translateY(0)";
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      revealables.forEach(function (n) { io.observe(n); });
    } else {
      revealables.forEach(function (n) { n.style.opacity = "1"; n.style.transform = "translateY(0)"; });
    }
  }

  // --- library index: tabs + format chips + pagination --------------------
  var idx = document.querySelector("[data-listing-index]");
  if (!idx) return;

  var perPage = parseInt(idx.getAttribute("data-per-page"), 10) || 12;
  var grid = idx.querySelector("[data-grid]");
  var cards = $$("[data-card]", idx);
  var tabs = $$("[data-tab]", idx);
  var chips = $$("[data-chip]", idx);
  var countLabel = idx.querySelector("[data-countlabel]");
  var emptyEl = idx.querySelector("[data-empty]");
  var moreWrap = idx.querySelector("[data-loadmore-wrap]");
  var moreBtn = idx.querySelector("[data-loadmore]");

  var activeTab = idx.getAttribute("data-default-tab") || "all";
  var activeKind = "all";
  var shown = perPage;
  var swapT = null;

  function cardCats(c) { return (c.getAttribute("data-cats") || "").split(/\s+/).filter(Boolean); }
  function matchesTab(c) { return activeTab === "all" || cardCats(c).indexOf(activeTab) >= 0; }
  function matchesKind(c) { return activeKind === "all" || c.getAttribute("data-kind") === activeKind; }

  function styleTab(btn, on) {
    btn.style.color = on ? "rgb(20, 24, 26)" : "rgb(138, 146, 150)";
    btn.style.borderBottomColor = on ? "rgb(242, 103, 58)" : "transparent";
    var b = btn.querySelector("[data-badge]");
    if (b) {
      b.style.background = on ? "rgba(242, 103, 58, 0.14)" : "rgba(20, 24, 26, 0.06)";
      b.style.color = on ? "rgb(199, 74, 30)" : "rgb(138, 146, 150)";
    }
  }
  function styleChip(btn, on) {
    btn.style.background = on ? "rgb(20, 69, 74)" : "none";
    btn.style.border = on ? "1px solid rgb(20, 69, 74)" : "1px solid rgba(20, 24, 26, 0.2)";
    btn.style.color = on ? "rgb(255, 255, 255)" : "rgb(74, 84, 87)";
  }

  function render() {
    var filtered = cards.filter(function (c) { return matchesTab(c) && matchesKind(c); });
    var visible = filtered.slice(0, shown);

    cards.forEach(function (c) { c.style.display = "none"; });
    visible.forEach(function (c) { c.style.display = "flex"; });

    if (countLabel) countLabel.textContent = Math.min(shown, filtered.length) + " of " + filtered.length;
    if (grid) grid.style.display = filtered.length === 0 ? "none" : "grid";
    if (emptyEl) emptyEl.style.display = filtered.length === 0 ? "block" : "none";
    if (moreWrap) moreWrap.style.display = filtered.length > shown ? "flex" : "none";

    // Format chips: "All" always; a kind chip shows only when the active tab
    // actually has a card of that kind (mirrors the v3 kindList filter).
    chips.forEach(function (chip) {
      var k = chip.getAttribute("data-chip");
      if (k === "all") { chip.style.display = ""; return; }
      var has = cards.some(function (c) { return matchesTab(c) && c.getAttribute("data-kind") === k; });
      chip.style.display = has ? "" : "none";
    });

    tabs.forEach(function (t) { styleTab(t, t.getAttribute("data-tab") === activeTab); });
    chips.forEach(function (c) { styleChip(c, c.getAttribute("data-chip") === activeKind); });
  }

  // Fade the grid out/in around a filter change (v3's 170ms swap).
  function swap() {
    if (grid) grid.style.opacity = "0";
    clearTimeout(swapT);
    swapT = setTimeout(function () {
      render();
      if (grid) grid.style.opacity = "1";
    }, 170);
  }

  tabs.forEach(function (t) {
    t.addEventListener("click", function () {
      var id = t.getAttribute("data-tab");
      if (id === activeTab) return;
      activeTab = id;
      // If the current format is unavailable under the new tab, drop to All.
      if (activeKind !== "all") {
        var has = cards.some(function (c) { return matchesTab(c) && c.getAttribute("data-kind") === activeKind; });
        if (!has) activeKind = "all";
      }
      shown = perPage;
      swap();
    });
  });

  chips.forEach(function (c) {
    c.addEventListener("click", function () {
      var k = c.getAttribute("data-chip");
      if (k === activeKind) return;
      activeKind = k;
      shown = perPage;
      swap();
    });
  });

  if (moreBtn) moreBtn.addEventListener("click", function () { shown += perPage; render(); });

  render();
})();
